import React from 'react';

import { DataPipelineNavItem } from '~/backup/shared/components/DataPipelineNavItem';
import { UploadNavItem } from '~/backup/shared/components/UploadNavItem';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

export const BackupOriginatorGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  return (
    <GlobalNav isFixed={isFixed} offsetHeaderCount={1}>
      <UploadNavItem />
      <DataPipelineNavItem />
      <GlobalNavRouterLinkItem
        to="/agent"
        label="Assistant"
        icon={<Icon icon="robot" />}
      />
    </GlobalNav>
  );
};
